import { fork, call, put, takeLatest } from 'redux-saga/effects';

import { showSpinner, hideSpinner } from '../global/actions';
import { ApiRequest } from '../../utils/api';
import { doCallApi } from '../global/sagas';
import { SEND_PASSWORD } from './constants';
import { sendPasswordFinished } from './actions';

// Change forgotten password outside MunMoi
export function* resetAndChangePassword(action) {
	yield put(showSpinner());
	yield call(doCallApi, true, ApiRequest.sendNewPassword, action.payload.token, action.payload.password);
	yield put(hideSpinner());
	yield put(sendPasswordFinished());
}

export function* root() {
	yield fork(takeLatest, SEND_PASSWORD, resetAndChangePassword);
}

export default [root];
